<template>
  <div>
      <v-card class="mt-6">
                    <v-card-title>
                      <v-col>
                        {{title}}
                      </v-col>
                      <v-spacer/>
                      <v-col>
                        <v-text-field
                          v-model="paymentsSearch"
                          append-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-col>  
                    </v-card-title>  
                    <v-card-text>                  
                       <v-data-table 
                           :headers="headers"
                           :items="paginatedResponse.data"
                           :server-items-length="paginatedResponse.totalCount"
                           :options.sync="options"
                           :loading="loading"
                           dense
                           fixed-header
                           height="75vh"
                           :footer-props="footerProps"
                           >
                          <template v-slot:item.requestedAt="{ item }">
                              <span v-if="item.requestedAt">
                                <localized-date-time :instant="item.requestedAt" />
                              </span>
                          </template>               
                          <template v-slot:item.transactionAmount="{ item }">
                              <span>
                                $ {{ item.transactionAmount }}
                              </span>
                          </template>            
                          <template v-slot:item.paidAt="{ item }">
                              <span v-if="item.paidAt">
                                <localized-date-time :instant="item.paidAt" />
                              </span>
                          </template>   
                          <template v-slot:item.actionButton="{ item }">
                                <router-link
                                    v-if="!!item.workflowGuid && !!workflowsWithDetailsAndPaymentView.find(x => x == item.workflowTypeDesc) && !!item.registrationId"
                                    class="no-text-decoration"
                                    :to="`/admin/${workflowsLinks.get(item.workflowTypeDesc)}/${item.registrationId}`">                                
                                    <v-btn class="mr-4"> View </v-btn>
                                </router-link>
                          </template>  
                      </v-data-table>
                    </v-card-text>   
                </v-card>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import adminService, { Payment } from "@/services/adminService";
import { MetaNames } from "@/constants";
import { PaginatedResponse, PaginationOptions } from "@/types/Pagination";
import { debounce } from "throttle-debounce";

export default Vue.extend({
  name: "AdminPayments",
  data: function() {
      return {
        title: MetaNames.AdminPayments,
        paginatedResponse: { data: [], page: 0, totalCount: 0 } as PaginatedResponse<Payment>,
        paymentsSearch: '',
        loading: false,
        loadRequestId: 0,
        loadPaymentsForSearch: null as any,
        options: {
          page: 1,
          itemsPerPage: 25,
          sortBy: ["id"],
          sortDesc: [true],
          groupBy: [],
          groupDesc: [],
          multiSort: false,
          mustSort: false,
        } as PaginationOptions,
        footerProps: { 'items-per-page-options': [10, 25, 50, 100] },
        headers: [
            { text: "#ID", align: "left", value: "id", width: "50px" },
            { text: "Registration type", align: "left", value: "workflowTypeDesc", width: "160px", sortable: false },
            { text: "Fee amount", align: "left", value: "transactionAmount", width: "50px" },
            { text: "Requested at", align: "left", value: "requestedAt", width: "100px" },
            { text: "Requested by admin", align: "left", value: "requestedBy", width: "100px" },
            { text: "Paid by", align: "left", value: "paidBy", width: "200px" },
            { text: "Paid at", align: "left", value: "paidAt", width: "100px" },
            { text: "Payment type", align: "left", value: "paymentTypeDesc", width: "100px", sortable: false },
            { text: "Admin notes", align: "left", value: "adminNotes", width: "200px" },
            { text: "", align: "left", value: "actionButton", width: "200px", sortable: false },
        ],
        workflowsWithDetailsAndPaymentView: [
          "KennelRegistration",
          "LitterRegistration",
          //PuppyRelease = 3,
          "LeaseRegistration",
          "AffiliateRegistration",
          "AffiliateRenewal",
          "KennelOwnersChange",
          "QTRegistration",
          // LEPRegistration = 9,
          // MemberRegistration = 10,
          // MemberRenewal = 11,
          // MemberAussieRenewal = 12,
          // PedigreeOrder = 13,
        ],
        workflowsLinks: new Map([
          ["KennelRegistration", "registration/kennels"],
          ["LitterRegistration", "registration/litters"],
          ["LeaseRegistration", "registration/lease"],          
          ["AffiliateRegistration", "registration/affiliate"],
          ["AffiliateRenewal", "renew/affiliate"],
          ["KennelOwnersChange", "changekennelowners"],
          ["QTRegistration", "registration/qtdogs"],
        ])
      };
  },
  methods: {
    load: async function () {
      const requestId = ++this.loadRequestId;
      this.loading = true;

      try {
        const response = await adminService.getPayments({
          ...this.options,
          page: (this.options.page ?? 1) - 1,
          itemsPerPage: this.options.itemsPerPage ?? 25,
        }, this.paymentsSearch);

        if (requestId === this.loadRequestId) this.paginatedResponse = response;
      } catch (error) {
        if (requestId === this.loadRequestId) this.$handleError(error);
      } finally {
        if (requestId === this.loadRequestId) this.loading = false;
      }
    },
  },
  watch: {
    paymentsSearch() {
      this.loadRequestId++;
      this.loading = false;
      this.loadPaymentsForSearch();
    },
    options: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  created: function () {
    this.loadPaymentsForSearch = debounce(300, () => {
      if (this.options.page === 1) this.load();
      else this.options.page = 1;
    });
  },
  beforeDestroy() {
    this.loadPaymentsForSearch.cancel();
  },
});
</script>
